// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingPlaceholder_container__13X2N"};